import React from 'react';
import useModal, { IModalPayload } from '@hooks/use-modal';
import { Modal } from 'antd';

import Widget from './Widget';
import { FileText } from 'lucide-react';

const PenaltyUndoBillingModal = () => {
  const [modal, setModal] =
    useModal<IModalPayload<{ ids: string[]; type: string }>>('update-penalty');

  const { ids = [] } = modal?.payload || {};

  const onClose = () => {
    setModal({ isOpen: false, payload: null });
  };

  return (
    <Modal
      destroyOnClose
      centered
      width={640}
      onCancel={onClose}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      footer={null}
      title={
        <>
          <FileText size={14} className={'mr-2'} />
          Undo penalty billing
        </>
      }
      visible={
        (modal?.isOpen && modal?.payload?.type === 'undo-billing') || false
      }
    >
      <Widget ids={ids} onClose={onClose} />
    </Modal>
  );
};

export default PenaltyUndoBillingModal;
